import { Permissions } from '@/shared/helpers/permissions'
import { useUserPermission } from '@/ui/hooks/useUserPermission'

export function UserPermissionManager({
  children
}: {
  children: (props: {
    checkPermission: (permission: Permissions) => boolean
    checkPermissionAndReturn: <T>(permission: Permissions, toReturn: T) => T[]
    checkNotPermissionAndReturn: <T>(
      permission: Permissions,
      toReturn: T
    ) => T[]
  }) => React.ReactNode
}) {
  const { checkPermission } = useUserPermission()

  const cr = <T>(
    permission: Permissions,
    invertCheck: boolean,
    toReturn: T
  ): T[] => {
    const hasPermission = checkPermission(permission)
    const res = invertCheck ? !hasPermission : hasPermission

    return res ? [toReturn] : []
  }

  const checkPermissionAndReturn = <T>(
    permission: Permissions,
    toReturn: T
  ): T[] => cr(permission, false, toReturn)

  const checkNotPermissionAndReturn = <T>(
    permission: Permissions,
    toReturn: T
  ): T[] => cr(permission, true, toReturn)

  return children({
    checkPermission,
    checkPermissionAndReturn,
    checkNotPermissionAndReturn
  })
}
